/**
 * Translation client-side script
 * Utilise l'API Google Translate
 */
document.addEventListener('DOMContentLoaded', function () {
    const API_URL = '/api/translate';

    // Éléments DOM
    const links = document.querySelectorAll('.language-switch');
    const frLink = document.getElementById('translate-fr');
    const enLink = document.getElementById('translate-en');
    const audioPlayer = document.querySelector('.audio-player');
    const iaPreviewContainer = document.getElementById('article-ia-preview');
    const titleElement = document.getElementById('article-title');
    const leadElement = document.getElementById('article-lead');
    const bodyElement = document.getElementById('article-main-content');

    // Sauvegarde du contenu original
    const originalContent = {
        title: titleElement ? titleElement.innerHTML : '',
        lead: leadElement ? leadElement.innerHTML : '',
        body: bodyElement ? bodyElement.innerHTML : ''
    };

    let isTranslating = false;

    // Gestion des clics
    links.forEach(link => {
        link.addEventListener('click', async function (e) {
            e.preventDefault();

            if (isTranslating) return;

            const targetLang = link.id === 'translate-fr' ? 'fr' : 'en';

            if (targetLang === 'fr') {
                // Restaurer le contenu original
                if (titleElement) titleElement.innerHTML = originalContent.title;
                if (leadElement) leadElement.innerHTML = originalContent.lead;
                if (bodyElement) bodyElement.innerHTML = originalContent.body;
                if (audioPlayer) audioPlayer.style.display = 'block';
                if (iaPreviewContainer) iaPreviewContainer.style.display = 'block';
                updateActiveLink('fr');
            } else {
                // Traduire en anglais
                await translateContent(targetLang, link);
            }
        });
    });

    async function translateContent(targetLang, clickedLink) {
        isTranslating = true;
        links.forEach(l => l.style.pointerEvents = 'none');
        clickedLink.classList.add('blinking');

        try {
            // Préparer les textes à traduire
            const textsToTranslate = [];
            const elements = [];

            if (titleElement && originalContent.title) {
                textsToTranslate.push(originalContent.title);
                elements.push({ el: titleElement, type: 'title' });
            }

            if (leadElement && originalContent.lead) {
                textsToTranslate.push(originalContent.lead);
                elements.push({ el: leadElement, type: 'lead' });
            }

            if (bodyElement && originalContent.body) {
                textsToTranslate.push(originalContent.body);
                elements.push({ el: bodyElement, type: 'body' });
            }

            if (textsToTranslate.length === 0) {
                throw new Error('Aucun contenu à traduire');
            }

            const response = await fetch(API_URL, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest'
                },
                body: JSON.stringify({
                    texts: textsToTranslate,
                    target: targetLang,
                    source: 'fr'
                })
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || 'Erreur API');
            }

            const data = await response.json();

            // Afficher les traductions
            if (data.status === 'success' && data.translations) {
                data.translations.forEach((translatedText, index) => {
                    const element = elements[index];
                    element.el.innerHTML = translatedText;
                });

                if (audioPlayer) audioPlayer.style.display = 'none';
                if (iaPreviewContainer) iaPreviewContainer.style.display = 'none';
                updateActiveLink(targetLang);
            } else {
                throw new Error(data.message || 'Format de réponse invalide');
            }

        } catch (error) {
            console.error('Erreur de traduction:', error);
            showError(error.message);
        } finally {
            isTranslating = false;
            links.forEach(l => l.style.pointerEvents = 'auto');
            clickedLink.classList.remove('blinking');
        }
    }

    function showError(message) {
        const errorHtml = `<div class="translation-error float-left w-full text-red-600 p-4 bg-red-100 rounded-md my-4">
            <strong>Erreur de traduction</strong>
            <p class="mt-2">${message}</p>
        </div>`;

        if (bodyElement) {
            bodyElement.innerHTML = errorHtml;
        }
    }

    function updateActiveLink(lang) {
        links.forEach(l => l.classList.remove('text-primary'));
        if (lang === 'fr' && frLink) {
            frLink.classList.add('text-primary');
        } else if (lang === 'en' && enLink) {
            enLink.classList.add('text-primary');
        }
    }
});
